import { render } from "./Divider.vue?vue&type=template&id=16ca6652"
import script from "./Divider.vue?vue&type=script&lang=js"
export * from "./Divider.vue?vue&type=script&lang=js"
script.render = render

export default script